import t from "../../theme";

const pageStyles = {
  route: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  page: {
    flex: 1,
    padding: "18px 14px 20px",
    fontFamily: t.font.family,
    background:
      "linear-gradient(135deg, rgba(84, 172, 52, 0.06) 0%, rgba(255, 255, 255, 0.34) 46%, rgba(0, 174, 239, 0.05) 100%)",
  },
  container: {
    width: "min(1120px, 100%)",
    margin: "0 auto",
    padding: 18,
    borderRadius: 24,
    background: t.glass.secondary,
    backdropFilter: t.blur.heavy,
    WebkitBackdropFilter: t.blur.heavy,
    border: `1px solid ${t.green.border}`,
    boxShadow: "0 10px 34px rgba(46, 125, 50, 0.10), inset 0 1px 0 rgba(255,255,255,0.45)",
  },
  listingContainer: {
    width: "min(1120px, 100%)",
    margin: "0 auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    marginBottom: 14,
    position: "relative",
  },
  listingHeader: {
    "@media (max-width: 640px)": {
      alignItems: "flex-start",
      gap: 10,
    },
  },
  listingHeaderCopy: {
    minWidth: 0,
    flex: 1,
  },
  eyebrow: {
    margin: "0 0 6px",
    color: "#008060",
    fontSize: "0.72rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  title: {
    margin: 0,
    color: "#101828",
    fontSize: "1.55rem",
    lineHeight: 1.18,
    fontWeight: 700,
  },
  subtitle: {
    margin: "6px 0 0",
    color: "#667085",
    fontSize: "0.84rem",
    lineHeight: 1.5,
    maxWidth: 680,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(270px, 1fr))",
    gap: 18,
  },
  card: {
    borderRadius: 20,
    border: `1px solid ${t.green.border}`,
    background: t.glass.primary,
    backdropFilter: t.blur.medium,
    WebkitBackdropFilter: t.blur.medium,
    boxShadow: "0 12px 30px rgba(46, 125, 50, 0.10)",
    padding: 18,
  },
  bookedDetailCard: {
    gridColumn: "1 / -1",
  },
  state: {
    borderRadius: 20,
    border: `1px dashed ${t.green.borderSelected}`,
    background: t.glass.primary,
    backdropFilter: t.blur.medium,
    WebkitBackdropFilter: t.blur.medium,
    padding: 32,
    color: "#667085",
    fontWeight: 700,
    textAlign: "center",
  },
  backButton: {
    borderRadius: 999,
    textTransform: "none",
    fontWeight: 700,
    color: t.green.dark,
    borderColor: t.green.borderSelected,
    background: t.green.bg,
    "&:hover": {
      borderColor: t.green.solid,
      background: t.green.bgHover,
    },
  },
  listingBackButton: {
    "@media (max-width: 640px)": {
      flex: "0 0 auto",
      minWidth: 0,
      padding: "3px 0",
      border: 0,
      borderRadius: 0,
      background: "transparent",
      whiteSpace: "nowrap",
      "&:hover": {
        border: 0,
        background: "transparent",
        textDecoration: "underline",
      },
    },
  },
  actionNotice: {
    borderRadius: 12,
    fontSize: "0.78rem",
    alignItems: "center",
    "& .MuiAlert-message": {
      padding: "4px 0",
    },
  },
  actionButton: {
    borderRadius: 999,
    textTransform: "none",
    fontWeight: 700,
    minHeight: 38,
    fontSize: "0.8rem",
    padding: "6px 14px",
    "&.MuiButton-contained": {
      background: t.green.gradient,
      color: t.brand.white,
      boxShadow: t.shadow.brand,
      "&:hover": {
        background: "linear-gradient(135deg, #4a9b2e 0%, #2d7a15 100%)",
        boxShadow: t.shadow.brandFocus,
      },
      "&.Mui-disabled": {
        background: t.glass.subtle,
        color: t.text.muted,
      },
    },
    "&.MuiButton-outlined": {
      color: t.green.dark,
      borderColor: t.green.borderSelected,
      background: t.green.bg,
      "&:hover": {
        borderColor: t.green.solid,
        background: t.green.bgHover,
      },
    },
  },
  detailShell: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 7fr) minmax(220px, 3fr)",
    gap: 14,
    alignItems: "start",
    "@media (max-width: 1024px)": {
      gridTemplateColumns: "minmax(0, 1fr)",
    },
  },
  detailLayout: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(240px, 0.36fr)",
    gap: 14,
    "@media (max-width: 1024px)": {
      gridTemplateColumns: "minmax(0, 1fr)",
    },
  },
  topCampaignsSidebar: {
    position: "sticky",
    top: 18,
    borderRadius: 20,
    border: `1px solid ${t.green.border}`,
    background: "rgba(238, 252, 241, 0.58)",
    backdropFilter: t.blur.medium,
    WebkitBackdropFilter: t.blur.medium,
    boxShadow: "0 12px 30px rgba(46, 125, 50, 0.08)",
    padding: 12,
    "@media (max-width: 1024px)": {
      position: "static",
    },
  },
  sidebarHeader: {
    marginBottom: 10,
  },
  sidebarEyebrow: {
    margin: "0 0 3px",
    color: "#008060",
    fontSize: "0.62rem",
    fontWeight: 900,
    letterSpacing: 0.4,
    textTransform: "uppercase",
  },
  sidebarTitle: {
    margin: 0,
    color: "#101828",
    fontSize: "0.95rem",
    lineHeight: 1.15,
    fontWeight: 800,
  },
  sidebarCampaignList: {
    display: "grid",
    gap: 9,
    "@media (max-width: 1024px)": {
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    },
    "@media (max-width: 640px)": {
      gridTemplateColumns: "minmax(0, 1fr)",
    },
  },
  sidebarCampaignButton: {
    width: "100%",
    padding: 0,
    border: 0,
    background: "transparent",
    cursor: "pointer",
    fontFamily: t.font.family,
    textAlign: "left",
    color: "inherit",
    borderRadius: 14,
    "&:hover img, &:hover div": {
      borderColor: t.green.borderSelected,
    },
    "&:focus-visible": {
      outline: `2px solid ${t.green.borderSelected}`,
      outlineOffset: 3,
    },
  },
  sidebarCampaignImage: {
    width: "100%",
    aspectRatio: "4 / 3",
    objectFit: "cover",
    display: "block",
    borderRadius: 12,
    border: "1px solid rgba(46, 125, 50, 0.16)",
    marginBottom: 7,
    transition: "border-color 0.18s ease",
  },
  sidebarCampaignImageFallback: {
    width: "100%",
    aspectRatio: "4 / 3",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 12,
    border: "1px solid rgba(46, 125, 50, 0.16)",
    marginBottom: 7,
    background:
      "linear-gradient(135deg, rgba(0, 174, 239, 0.14), rgba(84, 172, 52, 0.18))",
    transition: "border-color 0.18s ease",
    "& svg": {
      color: t.green.dark,
      fontSize: 24,
    },
  },
  sidebarCampaignName: {
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    color: "#101828",
    fontSize: "0.78rem",
    lineHeight: 1.25,
    fontWeight: 800,
  },
  sidebarCampaignMeta: {
    display: "block",
    marginTop: 4,
    color: "#667085",
    fontSize: "0.68rem",
    lineHeight: 1.25,
    fontWeight: 700,
  },
  sidebarCampaignSkeleton: {
    width: "100%",
    aspectRatio: "4 / 3.6",
    borderRadius: 14,
    background:
      "linear-gradient(100deg, rgba(255,255,255,0.36) 0%, rgba(183,234,209,0.42) 50%, rgba(255,255,255,0.36) 100%)",
  },
  sidebarEmpty: {
    borderRadius: 12,
    border: "1px dashed rgba(46, 125, 50, 0.24)",
    padding: 10,
    color: "#667085",
    fontSize: "0.72rem",
    lineHeight: 1.35,
    fontWeight: 700,
  },
  detailTitle: {
    margin: "10px 0 5px",
    color: "#101828",
    fontSize: "1.25rem",
    lineHeight: 1.18,
    fontWeight: 800,
  },
  statusRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
    "& span": {
      fontSize: "0.68rem",
      padding: "5px 9px",
    },
  },
  detailImage: {
    width: "100%",
    aspectRatio: "16 / 10",
    maxHeight: 250,
    objectFit: "cover",
    borderRadius: 14,
    border: "1px solid #edf2f7",
    marginBottom: 12,
    display: "block",
  },
  detailImageFallback: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    color: "#008060",
    background:
      "linear-gradient(135deg, rgba(0, 174, 239, 0.16), rgba(0, 128, 96, 0.20))",
    "& svg": {
      fontSize: 36,
      color: "#008060",
    },
    "& span": {
      color: "#475467",
      fontSize: "0.82rem",
      fontWeight: 800,
      lineHeight: 1,
    },
  },
  detailText: {
    margin: 0,
    color: "#475467",
    fontSize: "0.82rem",
    lineHeight: 1.42,
    "& > :first-of-type": {
      marginTop: 0,
    },
    "& > :last-child": {
      marginBottom: 0,
    },
    "& p": {
      margin: "0 0 0.75em",
    },
    "& ul, & ol": {
      margin: "0 0 0.75em",
      paddingLeft: "1.5em",
    },
    "& a": {
      color: "#008060",
      wordBreak: "break-word",
    },
    "& img": {
      maxWidth: "100%",
      height: "auto",
    },
  },
  metaGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: 0,
    marginTop: 18,
    "@media (max-width: 640px)": {
      gridTemplateColumns: "minmax(0, 1fr)",
    },
  },
  metaCard: {
    minWidth: 0,
    padding: "0 14px",
    borderLeft: "1px solid #e5e7eb",
    "&:first-of-type": {
      borderLeft: 0,
      paddingLeft: 0,
    },
    "@media (max-width: 640px)": {
      padding: "12px 0",
      borderLeft: 0,
      borderTop: "1px solid #e5e7eb",
      "&:first-of-type": {
        paddingTop: 0,
        borderTop: 0,
      },
    },
  },
  metaLabel: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    color: "#667085",
    fontSize: 11,
    fontWeight: 700,
    marginBottom: 6,
  },
  metaIcon: {
    color: t.green.solid,
    fontSize: 18,
    flex: "0 0 auto",
  },
  metaValue: {
    display: "block",
    color: "#101828",
    fontSize: "0.78rem",
    fontWeight: 800,
  },
  originalPrice: {
    color: "#98a2b3",
    textDecoration: "line-through",
    fontSize: "1.15rem",
    lineHeight: 1.1,
    fontWeight: 500,
  },
  pricePanel: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    alignItems: "stretch",
    marginTop: 28,
    position: "relative",
    border: `1px solid ${t.green.borderSelected}`,
    background: t.glass.primary,
    backdropFilter: t.blur.medium,
    WebkitBackdropFilter: t.blur.medium,
    boxShadow: "0 10px 24px rgba(46, 125, 50, 0.10)",
    overflow: "visible",
  },
  bookedPricePanel: {
    marginTop: 16,
    borderColor: "rgba(46, 125, 50, 0.14)",
    background: "rgba(255, 255, 255, 0.42)",
    boxShadow: "none",
  },
  priceBlock: {
    minHeight: 96,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 5,
    padding: "14px 12px",
    textAlign: "center",
  },
  bookedPriceBlock: {
    minHeight: 68,
    gap: 3,
    padding: "10px 12px",
    background: "transparent",
    border: 0,
    boxShadow: "none",
  },
  offerPriceBlock: {
    position: "relative",
    zIndex: 1,
    margin: "-1px 0",
    background: t.glass.heavy,
    border: `1px solid ${t.green.borderSelected}`,
    backdropFilter: t.blur.medium,
    WebkitBackdropFilter: t.blur.medium,
    boxShadow: "0 14px 30px rgba(46, 125, 50, 0.12)",
  },
  offerRibbon: {
    position: "absolute",
    top: -18,
    left: "50%",
    transform: "translateX(-50%)",
    minWidth: 130,
    padding: "3px 14px",
    background: t.green.dark,
    color: "#ffffff",
    fontSize: "0.56rem",
    fontWeight: 900,
    lineHeight: 1,
    textTransform: "uppercase",
    letterSpacing: 0.4,
    textAlign: "center",
    clipPath: "polygon(8% 0, 92% 0, 100% 100%, 0 100%)",
  },
  priceLabel: {
    color: "#667085",
    fontSize: "0.66rem",
    fontWeight: 800,
  },
  offerLabel: {
    color: t.green.dark,
    fontSize: "0.68rem",
    fontWeight: 900,
  },
  priceValue: {
    display: "block",
    color: t.green.dark,
    fontSize: "1.9rem",
    lineHeight: 0.95,
    fontWeight: 900,
    letterSpacing: 0,
  },
  bookedPriceValue: {
    fontSize: "1.05rem",
    lineHeight: 1.1,
    fontWeight: 800,
  },
  savingsValue: {
    display: "block",
    color: "#027a48",
    fontSize: "1.45rem",
    lineHeight: 1,
    fontWeight: 900,
  },
  bookedSavingsValue: {
    fontSize: "1rem",
    lineHeight: 1.1,
    fontWeight: 800,
  },
  discountPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 8px",
    borderRadius: 999,
    background: "#e8f6ed",
    color: "#2e7d32",
    fontSize: "0.62rem",
    fontWeight: 900,
  },
  discountIcon: {
    fontSize: 12,
  },
  priceHint: {
    color: "#98a2b3",
    fontSize: "0.62rem",
    fontWeight: 700,
  },
  detailFootnote: {
    margin: "8px 0 0",
    color: "#98a2b3",
    fontSize: "0.72rem",
    fontWeight: 600,
  },
  bookedFooterLinks: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
    marginTop: 16,
    paddingTop: 12,
    borderTop: "1px solid rgba(46, 125, 50, 0.16)",
  },
  bookedFooterLink: {
    border: 0,
    background: "transparent",
    color: t.green.dark,
    cursor: "pointer",
    fontFamily: t.font.family,
    fontSize: "0.84rem",
    fontWeight: 800,
    padding: 0,
    textDecoration: "none",
    "&:hover": {
      color: t.green.solid,
      textDecoration: "underline",
    },
    "&:focus-visible": {
      outline: `2px solid ${t.green.borderSelected}`,
      outlineOffset: 3,
      borderRadius: 6,
    },
  },
  bookedFooterSeparator: {
    width: 1,
    height: 16,
    background: "rgba(46, 125, 50, 0.22)",
  },
  bookedMetaCard: {
    background: "linear-gradient(180deg, #ecfdf3 0%, #f0f9ff 100%)",
    borderColor: "#b7ead1",
  },
  sideCard: {
    display: "flex",
    flexDirection: "column",
    gap: 9,
    position: "sticky",
    top: 18,
  },
  ticketList: {
    display: "grid",
    gap: 14,
  },
  ticketRow: {
    display: "grid",
    gridTemplateColumns: "132px minmax(0, 1fr) auto",
    gap: 16,
    alignItems: "start",
    borderRadius: 18,
    border: `1px solid ${t.green.border}`,
    background: t.glass.primary,
    backdropFilter: t.blur.medium,
    WebkitBackdropFilter: t.blur.medium,
    boxShadow: "0 8px 22px rgba(46, 125, 50, 0.08)",
    padding: 18,
  },
  ticketImageButton: {
    width: "100%",
    aspectRatio: "4 / 3",
    padding: 0,
    border: "1px solid #e5e7eb",
    borderRadius: 14,
    overflow: "hidden",
    background: "#f8fafc",
    cursor: "pointer",
    "&:disabled": {
      cursor: "default",
    },
  },
  ticketImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
  ticketImageFallback: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    aspectRatio: "4 / 3",
    border: "1px solid #d9eadf",
    borderRadius: 14,
    background: t.green.bg,
    color: t.green.dark,
    fontSize: "0.8rem",
    fontWeight: 800,
  },
  ticketTitle: {
    margin: 0,
    color: "#101828",
    fontSize: 18,
    fontWeight: 700,
  },
  ticketTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
    marginBottom: 6,
  },
  ticketDescription: {
    margin: "0 0 10px",
    maxWidth: 720,
    color: "#475467",
    fontSize: "0.86rem",
    lineHeight: 1.45,
  },
  ticketMeta: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    color: "#667085",
    fontSize: "0.78rem",
    fontWeight: 600,
  },
  ticketMetaItem: {
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    minWidth: 0,
    "& svg": {
      flex: "0 0 auto",
      color: t.green.dark,
      fontSize: 16,
    },
  },
  ticketActions: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    alignItems: "stretch",
    minWidth: 128,
  },
  "@media (max-width: 1024px)": {
    detailShell: {
      gridTemplateColumns: "1fr",
    },
    topCampaignsSidebar: {
      position: "static",
      order: 2,
    },
    sidebarCampaignList: {
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    },
    detailLayout: {
      display: "flex",
      flexDirection: "column",
      gridTemplateColumns: "1fr",
    },
    sideCard: {
      position: "static",
      width: "100%",
      order: 2,
    },
  },
  "@media (max-width: 640px)": {
    page: {
      padding: "14px 10px 28px",
    },
    card: {
      borderRadius: 16,
      padding: 14,
    },
    header: {
      alignItems: "flex-start",
      flexDirection: "column",
      gap: 10,
      marginBottom: 10,
    },
    backButton: {
      minHeight: 36,
      fontSize: "0.78rem",
    },
    title: {
      fontSize: 28,
    },
    detailTitle: {
      fontSize: "1.08rem",
      lineHeight: 1.2,
    },
    detailImage: {
      aspectRatio: "16 / 10",
      maxHeight: 180,
      borderRadius: 12,
      marginBottom: 10,
    },
    detailText: {
      fontSize: "0.76rem",
      lineHeight: 1.4,
    },
    metaGrid: {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gap: "12px 0",
      marginTop: 14,
    },
    metaCard: {
      padding: "0 10px",
      borderLeft: "1px solid #e5e7eb",
      "&:nth-of-type(odd)": {
        borderLeft: 0,
        paddingLeft: 0,
      },
    },
    metaLabel: {
      gap: 6,
      fontSize: 10,
      marginBottom: 5,
    },
    metaIcon: {
      fontSize: 16,
    },
    metaValue: {
      fontSize: "0.72rem",
    },
    pricePanel: {
      gridTemplateColumns: "1fr",
      marginTop: 26,
      overflow: "hidden",
    },
    priceBlock: {
      minHeight: "auto",
      padding: "14px 12px",
      borderTop: "1px solid #dceee4",
      "&:first-of-type": {
        borderTop: 0,
      },
    },
    offerPriceBlock: {
      order: -1,
      margin: 0,
      borderLeft: 0,
      borderRight: 0,
      boxShadow: "none",
    },
    offerRibbon: {
      top: 0,
      minWidth: 118,
      padding: "3px 11px",
      fontSize: "0.52rem",
    },
    priceValue: {
      fontSize: "1.65rem",
    },
    originalPrice: {
      fontSize: "1rem",
    },
    savingsValue: {
      fontSize: "1.2rem",
    },
    discountPill: {
      fontSize: "0.58rem",
      padding: "3px 8px",
    },
    sideCard: {
      position: "static",
    },
    sidebarCampaignList: {
      gridTemplateColumns: "1fr",
    },
    sidebarCampaignButton: {
      display: "grid",
      gridTemplateColumns: "72px minmax(0, 1fr)",
      gap: "0 10px",
      alignItems: "center",
    },
    sidebarCampaignImage: {
      gridRow: "1 / span 2",
      marginBottom: 0,
      aspectRatio: "1 / 1",
    },
    sidebarCampaignImageFallback: {
      gridRow: "1 / span 2",
      marginBottom: 0,
      aspectRatio: "1 / 1",
    },
    ticketRow: {
      gridTemplateColumns: "1fr",
    },
    ticketActions: {
      flexDirection: "row",
      flexWrap: "wrap",
      minWidth: 0,
    },
    ticketImageButton: {
      maxHeight: 180,
    },
    ticketImageFallback: {
      maxHeight: 180,
    },
  },
};

export default pageStyles;
